export default __webpack_public_path__ + "static/okr-linking-d9898947aeb97d37562c001958a4d519.mp4";